
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 76 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.858.428h-20v20h20v-20z","fill":"#000C1F"}}),_c('path',{attrs:{"d":"M30.858.428h-20v20h20v-20z","fill":"url(#paint0_linear_195_25210)","fill-opacity":".2"}}),_c('path',{attrs:{"d":"M40.857 10.452l-10-10.024v20.024l10-10z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M20.858 10.452l10-10.024h-20l10 10.024zM.834 10.452l10.024 10V.428L.834 10.452z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M20.858 10.452l-10 10h20l-10-10zM49.633 11.04H46.01v3.577h-1.812V6.24h1.812v3.435h3.623V6.24h1.812v8.377h-1.812V11.04zM55.822 14.781c-1.812 0-3.295-.73-3.318-2.73h1.812c.023.895.54 1.436 1.53 1.436.729 0 1.576-.376 1.576-1.2 0-.659-.565-.847-1.506-1.13l-.612-.164c-1.318-.377-2.635-.894-2.635-2.4 0-1.859 1.74-2.494 3.317-2.494 1.624 0 3.036.565 3.06 2.423h-1.813c-.07-.753-.517-1.2-1.364-1.2-.683 0-1.342.353-1.342 1.106 0 .612.565.8 1.742 1.177l.706.212c1.435.447 2.352.94 2.352 2.352-.023 1.883-1.858 2.612-3.505 2.612zM60.339 6.264h2.918c.54-.024 1.105 0 1.647.094 1.011.235 1.788.894 1.788 2.023 0 1.083-.682 1.624-1.67 1.883 1.129.211 1.976.776 1.976 2.023 0 1.906-1.883 2.33-3.342 2.33h-3.294l-.023-8.353zm2.918 3.482c.8 0 1.623-.165 1.623-1.13 0-.87-.753-1.105-1.506-1.105h-1.27v2.235h1.153zm.164 3.623c.847 0 1.67-.188 1.67-1.223 0-1.035-.705-1.224-1.576-1.224H62.08v2.447h1.341zM71.704 14.781c-2.706 0-3.906-1.717-3.906-4.282s1.341-4.424 4-4.424c1.67 0 3.294.753 3.341 2.636h-1.882c-.094-.847-.66-1.27-1.46-1.27-1.646 0-2.14 1.764-2.14 3.105s.494 2.894 2.07 2.894c.824 0 1.436-.447 1.553-1.294h1.883c-.189 1.93-1.718 2.635-3.46 2.635z","fill":"currentColor"}})])
          )
        }
      }
    